// oxlint-disable-next-line no-restricted-imports
import { ContextKindKey } from '@gonfalon/contexts/types';
import { fromJS, List, Record } from '@gonfalon/immutable-shim/immutableShim';
import type { CreateFunctionInput } from '@gonfalon/legacy-immutable/immutableUtils';

type TargetProps = {
  variation: number;
  values: List<string>;
  contextKind: string;
};

export class Target extends Record<TargetProps>({
  variation: 0,
  values: List(),
  contextKind: ContextKindKey.USER,
}) {
  isEmpty() {
    return !this.values || this.values.isEmpty();
  }
  getContextKind() {
    return this.contextKind || ContextKindKey.USER;
  }
}

export function createTarget(props: CreateFunctionInput<Target> = {}) {
  return props instanceof Target ? props : new Target(fromJS(props));
}
